var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExpress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 2.727v24.546c0 1.5-1.25 2.727-2.777 2.727H2.778C1.25 30 0 28.773 0 27.273V2.727C0 1.227 1.25 0 2.778 0h44.445C48.75 0 50 1.227 50 2.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "M0 0h50v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11.316 12.856l1.055 2.559h-2.103l1.048-2.559zm21.92.107h-4.06v1.127h3.995v1.69h-3.986v1.257h4.06v1.008l2.832-3.061-2.833-3.191-.008 1.17zM14.06 9.772h5.448l1.21 2.638 1.12-2.646h14.141l1.47 1.622 1.52-1.622h6.496l-4.799 5.252 4.75 5.22h-6.592l-1.47-1.622-1.534 1.622H12.76l-.673-1.622h-1.54l-.676 1.622H4.537L9.018 9.764h4.677l.364.008zm11.813 1.47H22.82l-2.045 4.822-2.216-4.822h-3.03V17.8l-2.81-6.56h-2.717l-3.248 7.517h2.12l.674-1.623h3.54l.674 1.623h3.709v-5.366l2.387 5.374h1.623l2.373-5.357v5.359h1.988l.033-7.528-.002.002zm12.737 3.774l3.451-3.774h-2.484l-2.184 2.353-2.11-2.353h-8.038v7.524h7.923l2.201-2.37 2.11 2.37h2.558l-3.426-3.75h-.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.fa3c344b2f8c260afd44d7cd6b897936.svg";
export { ForwardRef as ReactComponent };